import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import FeatureGrid from '@/pages/home/components/FeatureGrid';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import AboutArticleSection from '@/pages/home/components/AboutArticleSection';
import BlogGridSection from '@/pages/home/components/BlogGridSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import CTASection from '@/pages/home/components/CTASection';
import HomeFAQ from '@/pages/home/components/HomeFAQ';
import { SITE_URL } from '@/constants/site';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <CategoryGrid />
        <AboutArticleSection />
        <BlogGridSection />
        <TestimonialSection />
        <CTASection />
        <HomeFAQ />
      </main>
      <Footer />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'LitBuy Spreadsheets',
            url: SITE_URL,
            description: 'The ultimate resource hub for LitBuy Spreadsheet users, including tutorials, templates, comparisons, and setup guides.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            '@id': SITE_URL,
            url: SITE_URL,
            name: 'LitBuy Spreadsheet - Ultimate Resource Hub for Deal Tracking & Shopping Spreadsheets',
            description: 'LitBuy Spreadsheet is your complete resource for deal tracking spreadsheets, shopping templates, price comparison guides, and spreadsheet tutorials. Discover how LitBuy Spreadsheet helps you track deals across 14 categories with ease.',
            isPartOf: {
              '@type': 'WebSite',
              name: 'LitBuy Spreadsheets',
              url: SITE_URL,
            },
            primaryImageOfPage: {
              '@type': 'ImageObject',
              url: 'https://readdy.ai/api/search-image?query=A%20bright%20airy%20modern%20retail%20display%20with%20stylish%20colorful%20sneakers%20on%20transparent%20acrylic%20shelves%2C%20vibrant%20product%20photography%20with%20neon%20accent%20lighting%2C%20bold%20contemporary%20store%20interior%2C%20energetic%20dynamic%20composition%2C%20geometric%20shapes%20and%20clean%20lines%2C%20high-end%20fashion%20retail%20atmosphere&width=1600&height=900&seq=litbuy-hero-v2-001&orientation=landscape',
            },
          }),
        }}
      />
    </>
  );
}